export default function products() {
  return [
    'buyButton',
    'productFeature',
    'productCard',
    'productFeed',
    'productGrid',
  ];
}



// WEBPACK FOOTER //
// ./src/global-view/editor/page/droplets-tab/site-types/products.js